import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  Create,
  EditButton,
  DeleteButton,
  Filter,
  SearchInput,
  Pagination,
} from 'react-admin';

const TemplateBundleFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q[title_en_cont]" alwaysOn />
    <SearchInput source="q[title_fr_cont]" />
  </Filter>
);

export const TemplateBundleList = (props) => (
  <List {...props} filters={<TemplateBundleFilter />} perPage={25} pagination={<Pagination />}>
    <Datagrid rowClick="edit">
      <TextField source="title_en" label="Title (EN)" />
      <TextField source="title_fr" label="Title (FR)" />
      <BooleanField source="is_for_shop" />
      <BooleanField source="show_on_index" />
      <NumberField source="price" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const TemplateBundleEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="title_en" label="Title (English)" />
      <TextInput source="title_fr" label="Title (French)" />
      <TextInput source="title_de" label="Title (German)" />
      <TextInput source="title_it" label="Title (Italian)" />
      <TextInput source="title_pt" label="Title (Portuguese)" />
      <TextInput source="title_es" label="Title (Spanish)" />
      <TextInput source="description_en" multiline label="Description (English)" />
      <TextInput source="description_fr" multiline label="Description (French)" />
      <TextInput source="description_de" multiline label="Description (German)" />
      <TextInput source="description_it" multiline label="Description (Italian)" />
      <TextInput source="description_pt" multiline label="Description (Portuguese)" />
      <TextInput source="description_es" multiline label="Description (Spanish)" />
      <BooleanInput source="is_for_shop" />
      <BooleanInput source="show_on_index" />
      <NumberInput source="price" />
    </SimpleForm>
  </Edit>
);

export const TemplateBundleCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="title_en" label="Title (English)" />
      <TextInput source="title_fr" label="Title (French)" />
      <TextInput source="title_de" label="Title (German)" />
      <TextInput source="title_it" label="Title (Italian)" />
      <TextInput source="title_pt" label="Title (Portuguese)" />
      <TextInput source="title_es" label="Title (Spanish)" />
      <TextInput source="description_en" multiline label="Description (English)" />
      <TextInput source="description_fr" multiline label="Description (French)" />
      <TextInput source="description_de" multiline label="Description (German)" />
      <TextInput source="description_it" multiline label="Description (Italian)" />
      <TextInput source="description_pt" multiline label="Description (Portuguese)" />
      <TextInput source="description_es" multiline label="Description (Spanish)" />
      <BooleanInput source="is_for_shop" />
      <BooleanInput source="show_on_index" />
      <NumberInput source="price" />
    </SimpleForm>
  </Create>
);
